import Link from "next/link";
import React from "react";

export default function NextPrev({ next, prev }) {
  return (
    <div className="w-full flex items-start justify-between md:gap-12 gap-2 border-t-[1px] border-darkGrey/10 pt-8 md:pb-20 pb-8">
      <Prev prev={prev} />
      <p className="text-[#292929]/70 lg:text-lg md:text-base text-xs max-w-[100px] md:max-w-none text-center font-havletica shrink-0">
        Explore our other Work
      </p>
      <Next next={next} />
    </div>
  );
}
const Prev = ({ prev }) => {
  return (
    <Link
      href={`/projects/${prev?.slug}`}
      className="overflow-hidden lg:w-[488px] w-full lg:h-[377px] h-[150px] bg-[#E9E7DE] group relative lg:p-0 p-4"
    >
      <div className="w-full h-full bg-[#E9E7DE] absolute top-0 left-0 z-[10] group-hover:opacity-0 opacity-100 transition-opacity duration-500 ease"></div>
      <div
        className="flex flex-col items-center transition-transform duration-500 ease-in-out w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${prev?.thumbnail?.data?.attributes?.url})`,
        }}
      ></div>

      <div
        className="absolute inset-0 group-hover:scale-110 transition-transform duration-500 ease-in-out bg-cover bg-center"
        style={{
          backgroundImage: `url(${prev?.thumbnail?.data?.attributes?.url})`,
        }}
      ></div>
      <p className="text-sm text-darkGrey absolute md:top-8 top-4 md:left-8 left-4 z-[10] group-hover:text-[#F6F5F1] transition-all duration-300 ease">
        Previous
      </p>
      <p className="md:text-xl text-base leading-tight text-[#333333]/80 font-light font-havletica absolute md:bottom-8 bottom-4 md:left-8 left-4 z-[10] group-hover:text-[#F6F5F1] transition-all duration-300 ease">
        {prev?.title}
      </p>
    </Link>
  );
};
const Next = ({ next }) => {
  return (
    <Link
      href={`/projects/${next?.slug}`}
      className="overflow-hidden lg:w-[488px] w-full lg:h-[377px] h-[150px] bg-[#E9E7DE] group relative lg:p-0 p-4"
    >
      <div className="w-full h-full bg-[#E9E7DE] absolute top-0 left-0 z-[10] group-hover:opacity-0 opacity-100 transition-opacity duration-500 ease"></div>
      <div
        className="flex flex-col items-center transition-transform duration-500 ease-in-out w-full h-full bg-cover bg-center "
        style={{
          backgroundImage: `url(${next?.thumbnail?.data?.attributes?.url})`,
        }}
      ></div>

      <div
        className="absolute inset-0 group-hover:scale-110 transition-transform duration-500 ease-in-out bg-cover bg-center"
        style={{
          backgroundImage: `url(${next?.thumbnail?.data?.attributes?.url})`,
        }}
      ></div>
      <p className="text-sm text-darkGrey absolute md:top-8 top-4 md:right-8 right-4 z-[10] group-hover:text-[#F6F5F1] transition-all duration-300 ease">
        Next
      </p>
      <p className="md:text-xl text-base leading-tight text-[#333333]/80 text-right font-light font-havletica absolute md:bottom-8 bottom-4 md:right-8 right-4 z-[10] group-hover:text-[#F6F5F1] transition-all duration-300 ease">
        {next?.title}
      </p>
    </Link>
  );
};
